import i18n from "i18next"
import {initReactI18next} from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import HttpBackend from "i18next-http-backend"
import {ADMIN_LANGUAGE_STORAGE_KEY, ADMIN_LANGUAGES, getAdminLanguage} from "./utils/language"

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: getAdminLanguage(),
        supportedLngs: [...ADMIN_LANGUAGES],
        nonExplicitSupportedLngs: false,
        load: "currentOnly",
        ns: ["translation", "ui"],
        defaultNS: "translation",
        fallbackLng: "ru",
        debug: false,
        detection: {
            order: ["localStorage"],
            lookupLocalStorage: ADMIN_LANGUAGE_STORAGE_KEY,
            caches: ["localStorage"]
        },
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: true
        },
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json"
        }
    })

export default i18n
